module.exports = __webpack_public_path__ + "img/chocolate-cake.a6c97614.svg";